import AdvanceCriteria from "./AC.constant";
import { MarketList } from "../common.constant";
import { ScreenerState } from "../../types/screener.type";

export const advancedCriteriaLimit = 5;
export const MAX_SAVED_SCREENERS = 10;

export enum TableMode {
    NORMAL = 'normal',
    COMPACT = 'compact',
}

export const defaultScreenerState: ScreenerState = {
    isInitial: true,
    name: 'New Screener',
    markets: MarketList.map(item => ({
        cc: item.value,
        label: item.label,
        value: item.value,
        selected: false,
    })),
    sectors: [],
    criteria: AdvanceCriteria.map(item => ({
        ...item,
        selected: false,
        min: 0,
        max: 0,
        timeValue: item.timeOptions?.[0] || '',
        isInitial: true,
    })),
}

export const defaultColumnVisibility: { [key: string]: boolean } = {
    index: true,
    country: true,
    name: true,
    today: true,
    ticker: true,
    last: true,
    ccy: true,
    pc: true,
}